<p>home-page works!</p>
<p>Swagger ui</p>
<app-swagger-ui></app-swagger-ui>
<p>Swagger</p>
<app-swagger></app-swagger>
<p>Swagger editor</p>
<app-swagger-editor></app-swagger-editor>